import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/faq-accordion/components/FaqAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/faq-form/components/FaqForm.tsx");
